import vehicleDomainReducer from './domain'
import listings from './listings'
import vehicleSummaryCache from './summary-cache'

export const domain = vehicleDomainReducer
export const entities = {
  dealerListings: listings,
  dealerVehicleSummaryCache: vehicleSummaryCache,
}
